import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List, Map } from 'immutable';
import classNames from 'classnames';

import TagDefinitionForm from '../TagDefinitionForm';

const APPLICABLE_TO = [
    { id: 'sport', label: 'Sport' },
    { id: 'event', label: 'Event' },
    { id: 'competition', label: 'Competition' },
    { id: 'market-template', label: 'Market template' },
    { id: 'selection-template', label: 'Selection template' }
];

const INHERITANCE_RULES = [
    { id: 'competition-to-event', label: 'Competition to event' },
    { id: 'market-template-to-market', label: 'Market template to market' },
    { id: 'selection-template-to-selection', label: 'Selection template to selection' }
];

class TagManagement extends React.Component {
    static propTypes = {
        tags: ImmutablePropTypes.map,
        sports: ImmutablePropTypes.list,

        onEditTagRequest: PropTypes.func.isRequired,
        onQueryTagsRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        tags: Map(),
        sports: List()
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            opened: null
        };
    }

    UNSAFE_componentWillMount() {
       this.props.onQueryTagsRequest();
    }

    toggle(id, e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({
            opened: this.state.opened === id ? null : id
        });
    }

    saveTag(id, field, value) {
        if (field === 'defaultValue') {
            const { tags } = this.props;

            field = 'values';
            value = tags.getIn([ id, 'values' ]).map(val => {
                return val.set('isDefault', val.get('id') === value);
            }).toJS();
        }

        this.props.onEditTagRequest(id, {
            [field]: value
        });
    }

    buildTag(tag, id) {
        const { sports } = this.props;
        const { opened } = this.state;

        let tagApplicableTo = APPLICABLE_TO.filter(a => tag.get('applicableTo') && tag.get('applicableTo').contains(a.id)),
            inheritance = INHERITANCE_RULES.filter(a => tag.get('inheritance') && tag.get('inheritance').contains(a.id)),
            tagSports = sports.filter(s => tag.get('sports') && tag.get('sports').contains(s.get('id'))),
            tagSportsLabel = tagSports.slice(0, 2).map(s => s.get('name')).join(', ');

        if (tagSports.size > 2) {
            tagSportsLabel += ' and ' + (tagSports.size - 2) + ' more...';
        }

        let clsName = classNames({ 'tag-management-table-row__opened': opened === id });

        let row = (
            <tr key={ id } onClick={ this.toggle.bind(this, id) } className={ clsName }>
                <td>{ tag.get('label') }</td>
                <td>{ tagSportsLabel }</td>
                <td>{ tagApplicableTo.map(a => a.label).join(', ') }</td>
                <td>{ inheritance.map(a => a.label).join(', ') }</td>
            </tr>
        );

        let data = tag.toJS();
        data.defaultValue = tag.get('values').find(x => x.get('isDefault'));

        if (data.defaultValue) {
            data.defaultValue = data.defaultValue.get('id');
        }

        if (opened === id) {
            return [
                row,
                <tr key={ id + '-expandable' }>
                    <td colSpan={ 4 }>
                        <TagDefinitionForm
                            tag={ tag }
                            sports={ sports }
                            data={ data }
                            onChange={ this.saveTag.bind(this, id) }
                        />
                    </td>
                </tr>
            ];
        }

        return row;
    }

    render() {
        const { tags } = this.props;

        return (
            <div>
                <table className="table table__striped table__rows-highlighted table__tag-management">
                    <thead>
                        <tr>
                            <th className="tag-management-table-column__name">Tag name</th>
                            <th className="tag-management-table-column__sport">Sport(s)</th>
                            <th className="tag-management-table-column__applicable-to">Applied to level</th>
                            <th className="tag-management-table-column__inheritance">Inheritance</th>
                        </tr>
                    </thead>
                    <tbody>
                        { tags.map(this.buildTag.bind(this)).toArray() }
                    </tbody>
                </table>
            </div>
        );
    }

}

export default TagManagement;
